module.exports = __webpack_public_path__ + "static/media/SN.bc06ceda.png";